export function assertDefined<T>(value: T, errorMessage: string = 'Not Defined'): asserts value is NonNullable<T> {
  if (value === null || typeof value === 'undefined') {
    throw new Error(errorMessage);
  }
}
